import React, { Component } from 'react';
import python from "./images/buttons/python_logo.svg"
import reactpng from "./images/buttons/react_icon.svg"
import ensembl from "./images/buttons/ensembl.png"
import png23andMe from "./images/buttons/png23andMe.png"
import pngfacebook from "./images/buttons/facebook.png"

class Disclaimers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display:""
    };
  }

  handleClick = (e)=>{
    this.setState({display:"none"})
  }
            //<a target="_blank" rel="noopener noreferrer" href="https://you.23andme.com/tools/data/download/">

  render() {
    return(
      <div id='intro' style={{display:this.state.display}}>
        <a id='close' onClick={this.handleClick}>
          <span role="img" aria-label="X">&#x274e;&#xfe0f;</span>
        </a>
        <div id='intro-top'>
          <div id='legal'>
            <a href='https://moreygenetics.com/legal.htm'>
              <span role='img' aria-label='(info)'>&#x1f4cb;</span>&nbsp;&nbsp;
              Privacy policy and<br/>medical information disclosure
            </a>
          </div>
          <div id='source'>
            <a href={process.env.PUBLIC_URL+"/docs"}>
              <img src={python} alt='python'/><img src={reactpng} alt='react'/>
              Source
            </a>
          </div>
        </div>
        <div className='disclaimers'>
          <div className='disclaimer'>
            <a href="https://moreygenetics.com/ensembl_citation.htm">
              <img src={ensembl} alt="ensembl"/>
              <center>
                This site uses publicly available data from ensembl.org<br/>
                Citation and more info
              </center>
            </a>
          </div>
          <div className='disclaimer'>
            <img src={png23andMe} alt="23andMe"/>
            <center>
              Some genetic variants on this site show the new window symbol <span role="img" aria-label="**">&#x1f5d7;</span><br/>
              These variants were found on a v4 23andMe file downloaded in 2021, the link goes to 23andMe to look up your own allele
            </center>
          </div>
        </div>
      </div>
    )
  }
}
export default Disclaimers;